import { render } from "./buttons.vue?vue&type=template&id=4f391e2e"
import script from "./buttons.vue?vue&type=script&lang=js"
export * from "./buttons.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__